import type { Template } from "@/types";

export const LA_04_H4_V0: Template[] = [
    {
        id: "la-04-h4v0-01",
        name: "LA 01 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h4_v0_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 136, width: 332, height: 211, rotation: 0, imageRotation: 0 },
            { id: "2", x: 340, y: 136, width: 332, height: 211, rotation: 0, imageRotation: 0 },
            { id: "3", x: 680, y: 136, width: 332, height: 211, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1020, y: 136, width: 332, height: 211, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-02",
        name: "LA 02 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h4_v0_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 361, y: 41, width: 312, height: 197, rotation: 0, imageRotation: 0 },
            { id: "2", x: 361, y: 246, width: 312, height: 196, rotation: 0, imageRotation: 0 },
            { id: "3", x: 681, y: 41, width: 311, height: 197, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 246, width: 311, height: 196, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-03",
        name: "LA 03 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h4_v0_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 186, y: 47, width: 304, height: 191, rotation: 0, imageRotation: 0 },
            { id: "2", x: 186, y: 245, width: 304, height: 191, rotation: 0, imageRotation: 0 },
            { id: "3", x: 862, y: 47, width: 304, height: 191, rotation: 0, imageRotation: 0 },
            { id: "4", x: 862, y: 245, width: 304, height: 191, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-04",
        name: "LA 04 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h4_v0_04.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 42, y: 230, width: 293, height: 187, rotation: 0, imageRotation: 0 },
            { id: "2", x: 343, y: 230, width: 293, height: 187, rotation: 0, imageRotation: 0 },
            { id: "3", x: 722, y: 230, width: 293, height: 187, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1023, y: 230, width: 293, height: 187, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-05",
        name: "LA 05 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h4_v0_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 217, width: 332, height: 211, rotation: 0, imageRotation: 0 },
            { id: "2", x: 340, y: 217, width: 332, height: 211, rotation: 0, imageRotation: 0 },
            { id: "3", x: 680, y: 217, width: 332, height: 211, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1020, y: 217, width: 332, height: 211, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-06",
        name: "LA 06 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h4_v0_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 47, y: 47, width: 304, height: 191, rotation: 0, imageRotation: 0 },
            { id: "2", x: 47, y: 245, width: 304, height: 191, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1001, y: 47, width: 304, height: 191, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1001, y: 245, width: 304, height: 191, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-07",
        name: "LA 07 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h4_v0_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 42, y: 66, width: 293, height: 187, rotation: 0, imageRotation: 0 },
            { id: "2", x: 343, y: 66, width: 293, height: 187, rotation: 0, imageRotation: 0 },
            { id: "3", x: 722, y: 66, width: 293, height: 187, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1023, y: 66, width: 293, height: 187, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-08",
        name: "LA 08 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h4_v0_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 738, y: 66, width: 552, height: 349, rotation: 0, imageRotation: 0 },
            { id: "2", x: 231, y: 37, width: 214, height: 131, rotation: 0, imageRotation: 0 },
            { id: "3", x: 231, y: 176, width: 214, height: 131, rotation: 0, imageRotation: 0 },
            { id: "4", x: 231, y: 315, width: 214, height: 130, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-09",
        name: "LA 09 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h4_v0_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 103, y: 204, width: 450, height: 241, rotation: 0, imageRotation: 0 },       
            { id: "2", x: 103, y: 39, width: 221, height: 158, rotation: 0, imageRotation: 0 },
            { id: "3", x: 332, y: 39, width: 221, height: 158, rotation: 0, imageRotation: 0 },
            { id: "4", x: 718, y: 57, width: 591, height: 369, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-10",
        name: "LA 10 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h4_v0_10.png",
        size: [1352, 483],
        style: {},
        slots: [     
            { id: "1", x: 288, y: 47, width: 199, height: 124, rotation: 0, imageRotation: 0 },
            { id: "2", x: 288, y: 179, width: 199, height: 124, rotation: 0, imageRotation: 0 },
            { id: "3", x: 288, y: 311, width: 199, height: 124, rotation: 0, imageRotation: 0 },
            { id: "4", x: 494, y: 47, width: 616, height: 388, rotation: 0, imageRotation: 0 }
        ],
    }
];